module.exports = __webpack_public_path__ + "static/img/shakeprove.1b0d5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shakeprove.png
// module id = /iqT
// module chunks = 21